import ActionTypes from "../constants/action_types";

export default function clearClients() {
  return {
    type: ActionTypes.CLIENTS_CLEAR.SUCCESS,
  };
}
